<template>
  <CommonSplash :showAnimation="true">
    <template #screen>
      <slot/>
    </template>
  </CommonSplash>
</template>
